import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4343cf20&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=4343cf20&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=4343cf20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343cf20",
  null
  
)

export default component.exports